var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.accessoryGroupProp.length
    ? _c("div", { staticClass: "accessory-picker" }, [
        _c("h3", { staticClass: "heading" }, [_vm._v("Add your extras")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "product-options product-options--accessories" },
          [
            _c(
              "div",
              { staticClass: "product-options__row" },
              _vm._l(_vm.accessoryGroupProp, function(accessory) {
                return _c("Accessory", {
                  key: accessory.id,
                  attrs: { accessoryProp: accessory },
                  on: {
                    accessorySelected: _vm.onAccessorySlected,
                    accessoryRemoved: _vm.onAccessoryRemoved
                  }
                })
              }),
              1
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }